import { FieldError, type FieldErrorProps } from 'react-aria-components';
import { composeTailwindRenderProps } from '../../utils';

/**
 * The FieldError component is used to display an error message for a field.
 *
 * @param props - The props for the FieldError component.
 * @example
 * <FieldError>
 *   Error Message
 * </FieldError>
 */
function _FieldError(props: FieldErrorProps) {
  const { className, ...other } = props;

  return <FieldError {...other} className={composeTailwindRenderProps(className, 'text-error-primary text-sm')} />;
}

export { _FieldError as FieldError };
